import React from "react";
import "./Button.scss";
import Skeleton from "../Skeleton/Skeleton";
import AnimationIcons from "../AnimationIcons/AnimationIcons";

const Button = ({ key, children, onClick, className, icon, type, style , width = 'fit-content', raised = false,loading=false,disabled,outline=false,severity  }) => {


    return (
        
        <div className="container-button animate__animated animate__fadeInUp" style={{width}}>
            <button disabled={disabled || loading} key={key} type={type} className={`button ${className} ${raised ? 'raised' : ''} ${outline ? 'outline' : ''} ${severity ? `button-${severity}` : ''}`} onClick={onClick} style={{...style, width}} disabled={disabled || loading}>
                { loading ? <AnimationIcons velocity={2} animation="rotate" direction="left" icon="restart_alt" /> : icon && <span data-icon={icon} className="icon" />}
                {children}
            </button>
        </div>
    );
}

export default Button;